function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3627",
  "data-name": "Group 3627",
  transform: "translate(-440 -515)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3602",
  "data-name": "Group 3602",
  transform: "translate(440 515)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_72",
  "data-name": "Ellipse 72",
  cx: 18.5,
  cy: 18.5,
  r: 18.5,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3621",
  "data-name": "Group 3621",
  transform: "translate(441.156 507.711)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  d: "M10.711,0A10.711,10.711,0,1,1,0,10.711,10.711,10.711,0,0,1,10.711,0Zm0,2.1a8.609,8.609,0,1,0,8.609,8.609A8.609,8.609,0,0,0,10.711,2.1Z",
  transform: "translate(6.844 15.289)",
  fill: "#2c3131",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("rect", {
  id: "pendulum-line",
  width: 2.102,
  height: 13.195,
  transform: "matrix(0.919, 0.395, -0.395, 0.919, 19.196, 19.524)",
  fill: "#2c3131"
})));

function SvgPen(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.f61381398e2377476c0bf714139437a0.svg";
export { ForwardRef as ReactComponent };